import { useContext } from "react";
import { AppContext } from "../AppContext";

export const useAppContext = () => {
    const appContext = useContext(AppContext);
    if (appContext === undefined) {
      throw new Error("useCollectionContext must be inside a ContextProvider");
    }
    return appContext;
  };